import type { FormKitNode } from '@formkit/core'
import CountriesEnum from '~/enums/CountriesEnum'
import CountriesZipCodeLengthEnum from '~/enums/CountriesZipCodeLengthEnum'

export default (node: FormKitNode): boolean => {
  const countryId = node.props.attrs['data-country-id'] ?? null
  const inputValue: string = node.value as string

  switch (countryId) {
    case CountriesEnum.Lithuania: {
      return digitsOnlyExactLength(inputValue, CountriesZipCodeLengthEnum.Lithuania)
    }
    case CountriesEnum.Latvia: {
      return digitsOnlyExactLength(inputValue, CountriesZipCodeLengthEnum.Latvia)
    }
    case CountriesEnum.Estonia: {
      return digitsOnlyExactLength(inputValue, CountriesZipCodeLengthEnum.Estonia)
    }
    default: {
      return alphanumericLengthBetween(inputValue, 3, 19)
    }
  }
}

function digitsOnlyExactLength(value: string, length: number) {
  return value.length === length && /^\d+$/.test(value)
}

function alphanumericLengthBetween(value: string, min: number, max: number) {
  return value.length >= min && value.length <= max && /^[^\- ][a-zA-Z0-9 -]+[^\- ]$/.test(value)
}
